import React from 'react';

import PropTypes from 'prop-types';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';

import MainNavigationLogo from 'components/common/navigation/MainNavigation/MainNavigationLogo';
import { selectBusinessType } from 'selectors';

import { MERCHANT_BUSINESS_TYPE } from '../../../../../../constants/constants';
import SectionSelect from '../../../SectionSelect';
import SideNavigationItems from '../SideNavigationContent';

import './DesktopSideNavigation.scss';

const propTypes = {
  rootRoutePath: PropTypes.string.isRequired,
};

export default function DesktopSideNavigation({ rootRoutePath }) {
  const { eCommerce: eCommerceEnabled } = useFlags();

  const businessType = useSelector(selectBusinessType);

  const showProductSelector = eCommerceEnabled && businessType === MERCHANT_BUSINESS_TYPE;

  return (
    <div className="desktop-side-navigation">
      <div className="top-container">
        {showProductSelector && <SectionSelect />}
        <SideNavigationItems rootRoutePath={rootRoutePath} />
      </div>

      <div className="bottom-container">
        <span>POWERED BY</span>
        <MainNavigationLogo />
      </div>
    </div>
  );
}

DesktopSideNavigation.propTypes = propTypes;
